import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/authGuard/auth-guard';

export const routes: Routes = [
	{
      path: '',
      loadChildren: () => import('./modules/authentication/authentication-module').then(m => m.AuthenticationModule)
  },
  {
      path:'vrtp-new',
      canActivate: [AuthGuard],
      loadChildren: () => import('./modules/main-layout/main-layout-module').then(m => m.MainLayoutModule)
  },
  { path: '**', redirectTo: 'vrtp-new' },
];
